import { RootState } from '@/store/types'
import { Getter } from 'vuex'
import { ModalState } from '../types'

const currentModal: Getter<ModalState, RootState> = (state) => {
  return state.current
}

export default currentModal
